import { zodMoment } from '@qapline/helpers';
import { z } from 'zod';

import { locationSchema } from '../../location/schemas/location';

export const commissionLoadingSchema = z.object({
    commissionLoading_id: z.number(),
    commission_id: z.number(),

    order: z.number(),
    dateFrom: zodMoment().nullable(),
    dateTo: zodMoment().nullable(),
    dateReal: zodMoment().nullable(),
    timeFrom: z.string().nullable(),
    timeTo: z.string().nullable(),
    timeReal: zodMoment().nullable(),
    referenceNumber: z.string().nullable(),
    note: z.string().nullable(),
    locationVersion_id: z.number().nullable(),
    location: locationSchema.nullable(),

    deleted: z.boolean(),
});

export type TCommissionLoading = z.infer<typeof commissionLoadingSchema>;
